import httpService from "../httpService";

export default {
  findByHcCaseMaster(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get(`/hcCaseHotelLocationView/findByHcCaseMaster`, {params});
  }
};



// WEBPACK FOOTER //
// ./src/services/khachsan/hcCaseHotelLocationViewService.js